<template>
  <sui-label v-if="message" pointing color="red">
    {{ message }}
  </sui-label>
</template>

<script>
import Vue from 'vue'
import SuiVue from 'semantic-ui-vue'
Vue.use(SuiVue)

export default {
  props: {
    message: {
      type: String,
      default: () => '',
    },
  },
}
</script>
